// Utility to manage history entries with deduplication
let historyInstance = null;

class HistoryManager {
  constructor() {
    if (historyInstance) {
      return historyInstance;
    }
    
    this.history = [];
    this.loadHistory();
    historyInstance = this;
  }

  loadHistory() {
    // First check for saved database data
    const savedDatabaseHistory = localStorage.getItem('savedHistory');
    if (savedDatabaseHistory) {
      this.history = JSON.parse(savedDatabaseHistory);
      // Save to regular storage and clean up
      this.saveHistory();
      localStorage.removeItem('savedHistory');
      return;
    }
    
    // Fall back to regular saved history
    const savedHistory = localStorage.getItem('changeHistory');
    if (savedHistory) {
      this.history = JSON.parse(savedHistory);
    }
    else {
      this.history = [];
    }
  }

  saveHistory() {
    localStorage.setItem('changeHistory', JSON.stringify(this.history));
  }

  addEntry(entry, userEmail) {
    const newEntry = {
      ...entry,
      timestamp: new Date().toISOString(),
      userEmail
    };

    // Check for duplicate entries within last 2 seconds
    const now = new Date(newEntry.timestamp).getTime();
    const recentDuplicate = this.history[0] && (
      (this.history[0].type === 'single' && 
        JSON.stringify(this.history[0].action) === JSON.stringify(entry.action) &&
        JSON.stringify(this.history[0].rowData) === JSON.stringify(entry.rowData)
      ) ||
      (this.history[0].type === 'bulk' && 
        JSON.stringify(this.history[0].action) === JSON.stringify(entry.action) &&
        JSON.stringify(this.history[0].filters) === JSON.stringify(entry.filters)
      ) ||
      (this.history[0].type === 'rule' && 
        JSON.stringify(this.history[0].ruleName) === JSON.stringify(entry.ruleName) &&
        JSON.stringify(this.history[0].actions) === JSON.stringify(entry.actions) &&
        JSON.stringify(this.history[0].filters) === JSON.stringify(entry.filters)
      )
      ) && now - new Date(this.history[0].timestamp).getTime() < 2000;

    // If a duplicate entry was found, don't add the new one
    if (recentDuplicate) {
      return this.history;
    }

    this.history = [newEntry, ...this.history];
    this.saveHistory();
    return this.history;
  }

  getHistory() {
    return this.history;
  }
  
  setHistory(history) {
    if (Array.isArray(history)) {
      this.history = history;
      this.saveHistory();
    }
    return this.history;
  }

  // Helper function to create single change history entry
  createSingleChangeEntry(rowData, action) {
    return {
      type: 'single',
      action,
      rowData
    };
  }

  // Helper function to create bulk action history entry
  createBulkActionEntry(action, affectedRows, filters) {
    return {
      type: 'bulk',
      action,
      affectedRows,
      filters: { ...filters }
    };
  }

  // Helper function to create rule history entry
  createRuleEntry(ruleName, filters, actions, affectedRows) {
    return {
      type: 'rule',
      ruleName,
      actions,
      affectedRows,
      filters: { ...filters }
    };
  }
}

// Export a singleton instance
export const historyManager = new HistoryManager();
